export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref10262.5f5175d9.jpg";